import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant pour tracker les changements de route avec Google Tag Manager
 * Dans une SPA React, les changements de route ne déclenchent pas automatiquement
 * les événements de page view, il faut les envoyer manuellement au dataLayer
 */
function GTMTracker() {
  const location = useLocation();

  useEffect(() => {
    // Vérifier que window.dataLayer existe (GTM / gtag doit être chargé)
    if (typeof window !== 'undefined' && window.dataLayer) {
      const page_path = location.pathname + location.search;
      const page_title = document.title;
      const page_location = window.location.href;

      // GTM custom event (compat)
      window.dataLayer.push({
        event: 'page_view',
        page_path,
        page_title,
        page_location,
      });

      // GA4 page_view explicite (SPA) — ID G-Z5R5VG9SFM
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path,
          page_title,
          page_location,
        });
      }
    } else {
      console.warn('⚠️ GTM/GA: dataLayer not found. Make sure tags are loaded.');
    }
  }, [location]);

  return null; // Ce composant ne rend rien
}

export default GTMTracker;







